// import Clarity from '@microsoft/clarity';
import EntryPage from "components/EntryPage";
import ErrorBoundary from "components/ErrorBoundary";
import LazyLoadingSpinner from "components/LazyLoadingSpinner";
import PropTypes from "prop-types";
import React, { Suspense } from "react";
import { BrowserRouter, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import initNewRelic from "utils/new-relic";

// const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID || ''
// Clarity.init(projectId);
initNewRelic();

const App = () => {
  function Scroll(prop) {
    React.useEffect(() => {
      window.scrollTo(0, 0);
    }, [prop.location]);

    return prop.children;
  }

  Scroll.propTypes = {
    location: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  };

  const ScrollToTop = withRouter(Scroll);

  return (
    <ErrorBoundary>
      <div className="tw-font-inter">
        <ToastContainer />
        <BrowserRouter>
          <ScrollToTop>
            <Suspense fallback={<LazyLoadingSpinner />}>
              <EntryPage />
            </Suspense>
          </ScrollToTop>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
};

export default App;
